export const useBannerImagesSSR = (props) => {
  const sortedImages = props?.images?.sort((a, b) => a?.order - b?.order);

  return {
    bannerImageDesktop: sortedImages?.filter((el) => el?.is_desktop === true),
    bannerImageMobile: sortedImages?.filter((el) => el?.is_desktop === false),
  };
};
